import { render } from "./InventoryItemStockDetailsTab.vue?vue&type=template&id=bfa0588c"
import script from "./InventoryItemStockDetailsTab.vue?vue&type=script&lang=js"
export * from "./InventoryItemStockDetailsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__